import { createTableColumn as createCustomFieldColumn } from '../../../services/customFieldsV2';

export const contactTableColumns = {
  name: {
    Header: 'Contacts',
    accessor: 'name',
    width: 300,
    hide: false,
    pinned: 'left',
    cellRenderer: 'contactNameRenderer',
    suppressMovable: true,
    disableSortBy: false,
    hideOnTableColumn: true,
    valueFormatter: ({ data: { original } }) => original.fullName,
  },
  jobTitle: {
    Header: 'Current job title',
    accessor: 'jobTitle',
    disableSortBy: false,
    width: 300,
    cellRenderer: 'contactCompanyRenderer',
    valueFormatter: ({ data: { jobTitle } }) =>
      (jobTitle?.experiences ?? []).map((exp) => exp[jobTitle.columnKey]).join(', '),
  },
  company: {
    Header: 'Current company',
    accessor: 'company',
    width: 240,
    disableSortBy: false,
    disablePadding: true,
    cellRenderer: 'contactCompanyRenderer',
    valueFormatter: ({ data: { company } }) =>
      (company?.experiences ?? []).map((exp) => exp[company.columnKey]).join(', '),
  },
  contactOf: {
    Header: 'Contact of',
    accessor: 'contactOf',
    width: 280,
    disableSortBy: false,
    disablePadding: true,
    cellRenderer: 'contactOfRenderer',
    valueFormatter: ({ data: { contactOf } }) => (contactOf ?? []).map((of) => of.name).join(', '),
  },
  companySize: {
    Header: 'Current company size',
    accessor: 'companySize',
    width: 240,
    disableSortBy: false,
    disablePadding: true,
    cellRenderer: 'contactRenderer',
    valueFormatter: ({ value }) => value ?? '',
  },
  companyFunding: {
    Header: 'Current company funding stage',
    accessor: 'companyFunding',
    width: 240,
    disableSortBy: false,
    disablePadding: true,
    cellRenderer: 'contactRenderer',
    valueFormatter: ({ value }) => value ?? '',
  },
  linkedinProfile: {
    Header: 'LinkedIn profile',
    accessor: 'linkedinProfile',
    width: 300,
    disableSortBy: true,
    disablePadding: true,
    cellRenderer: 'contactLinkRenderer',
  },
  linkedinTagline: {
    Header: 'LinkedIn tagline',
    accessor: 'linkedinTagline',
    width: 240,
    disableSortBy: true,
    disablePadding: true,
    cellRenderer: 'contactRenderer',
    valueFormatter: ({ value }) => value ?? '',
  },
  workEmail: {
    Header: 'Work email',
    accessor: 'workEmail',
    width: 240,
    disableSortBy: true,
    disablePadding: true,
    cellRenderer: 'contactEmailRenderer',
    valueFormatter: ({ value }) => value?.join(', ') ?? '',
  },
  personalEmail: {
    Header: 'Personal email',
    accessor: 'personalEmail',
    width: 240,
    disableSortBy: true,
    disablePadding: true,
    cellRenderer: 'contactEmailRenderer',
    valueFormatter: ({ value }) => value?.join(', ') ?? '',
  },
  location: {
    Header: 'Location',
    accessor: 'location',
    width: 240,
    disableSortBy: false,
    disablePadding: true,
    cellRenderer: 'contactRenderer',
    valueFormatter: ({ value }) => value ?? '',
  },
  seniority: {
    Header: 'Seniority',
    accessor: 'seniority',
    width: 240,
    disableSortBy: false,
    disablePadding: true,
    cellRenderer: 'contactRenderer',
    valueFormatter: ({ value }) => value ?? '',
  },
  yearsOfExperience: {
    Header: 'Years of experience',
    accessor: 'yearsOfExperience',
    width: 240,
    disableSortBy: false,
    disablePadding: true,
    cellRenderer: 'contactRenderer',
    valueFormatter: ({ value }) => value ?? '',
  },
  yearsInCurrentCompany: {
    Header: 'Years in current company',
    accessor: 'yearsInCurrentCompany',
    width: 240,
    disableSortBy: false,
    disablePadding: true,
    cellRenderer: 'contactRenderer',
    valueFormatter: ({ value }) => value ?? '',
  },
  industry: {
    Header: 'Industries',
    accessor: 'industry',
    width: 240,
    disableSortBy: true,
    disablePadding: true,
    cellRenderer: 'contactRenderer',
    valueFormatter: ({ value }) => value ?? '',
  },
  list: {
    Header: 'Lists',
    accessor: 'list',
    width: 280,
    disableSortBy: true,
    disablePadding: true,
    cellRenderer: 'contactListRenderer',
    valueFormatter: ({ data: { list } }) => list?.map((l) => l.name).join(', ') ?? '',
  },
  tags: {
    Header: 'Tags',
    accessor: 'tags',
    width: 240,
    disableSortBy: true,
    disablePadding: true,
    cellRenderer: 'contactTagsRenderer',
    valueFormatter: ({ data: { tags } }) => tags?.map((t) => t.tag).join(', ') ?? '',
  },
  notes: {
    Header: 'Notes',
    accessor: 'notes',
    width: 200,
    disableSortBy: true,
    disablePadding: true,
    cellRenderer: 'contactNoteRenderer',
    valueFormatter: ({ value }) => value ?? '',
  },
  source: {
    Header: 'Source',
    accessor: 'source',
    width: 200,
    disableSortBy: true,
    disablePadding: true,
    cellRenderer: 'contactSourceRenderer',
    valueFormatter: ({ value }) => value ?? '',
  },
  firstSeen: {
    Header: 'First seen',
    accessor: 'firstSeen',
    width: 240,
    disableSortBy: false,
    disablePadding: true,
    cellRenderer: 'contactRenderer',
    valueFormatter: ({ value }) => value ?? '',
  },
  addedBy: {
    Header: 'Added to list by',
    accessor: 'addedBy',
    width: 240,
    disableSortBy: true,
    disablePadding: true,
    cellRenderer: 'contactRenderer',
    valueFormatter: ({ value }) => value ?? '',
  },
  jobApplications: {
    Header: 'Job applications',
    accessor: 'jobApplications',
    width: 240,
    disableSortBy: true,
    disablePadding: true,
    cellRenderer: 'contactJobApplicationRenderer',
    valueFormatter: ({ value }) => value ?? '',
  },
  talentNetworkSignup: {
    Header: 'Joined talent network',
    accessor: 'talentNetworkSignup',
    width: 240,
    disableSortBy: false,
    disablePadding: true,
    cellRenderer: 'contactRenderer',
    valueFormatter: ({ value }) => value ?? '',
  },
  signupDate: {
    Header: 'Signup date',
    accessor: 'signupDate',
    width: 240,
    disableSortBy: false,
    disablePadding: true,
    cellRenderer: 'contactRenderer',
    valueFormatter: ({ value }) => value ?? '',
  },
  preferredJobFunction: {
    Header: 'Preferred job function',
    accessor: 'preferredJobFunction',
    width: 240,
    disableSortBy: true,
    disablePadding: true,
    cellRenderer: 'contactRenderer',
    valueFormatter: ({ value }) => value ?? '',
  },
  levelOfExperience: {
    Header: 'Level of experience',
    accessor: 'levelOfExperience',
    width: 240,
    disableSortBy: true,
    disablePadding: true,
    cellRenderer: 'contactRenderer',
    valueFormatter: ({ value }) => value ?? '',
  },
  preferredLocation: {
    Header: 'Preferred location',
    accessor: 'preferredLocation',
    width: 240,
    disableSortBy: true,
    disablePadding: true,
    cellRenderer: 'contactRenderer',
    valueFormatter: ({ value }) => value ?? '',
  },
  workEnvironment: {
    Header: 'Work environment',
    accessor: 'workEnvironment',
    width: 240,
    disableSortBy: true,
    disablePadding: true,
    cellRenderer: 'contactRenderer',
    valueFormatter: ({ value }) => value ?? '',
  },
  jobSearchStatus: {
    Header: 'Job search status',
    accessor: 'jobSearchStatus',
    width: 240,
    disableSortBy: true,
    disablePadding: true,
    cellRenderer: 'contactRenderer',
    valueFormatter: ({ value }) => value ?? '',
  },
  resume: {
    Header: 'Resume',
    accessor: 'resume',
    width: 240,
    disableSortBy: true,
    disablePadding: true,
    cellRenderer: 'contactResumeRenderer',
    valueFormatter: () => 'Resume requires authentication — view in Getro',
  },
  website: {
    Header: 'Website',
    accessor: 'website',
    width: 240,
    disableSortBy: true,
    disablePadding: true,
    cellRenderer: 'contactLinkRenderer',
    valueFormatter: ({ value }) => value ?? '',
  },
  jobAlerts: {
    Header: 'Job alerts',
    accessor: 'jobAlerts',
    width: 240,
    disableSortBy: true,
    disablePadding: true,
    cellRenderer: 'contactRenderer',
    valueFormatter: ({ value }) => value ?? '',
  },
  jobAlertsKeywords: {
    Header: 'Job alerts keywords',
    accessor: 'jobAlertsKeywords',
    width: 240,
    disableSortBy: true,
    disablePadding: true,
    cellRenderer: 'contactRenderer',
    valueFormatter: ({ value }) => value ?? '',
  },
};

export const createColumnsFromFields = (visibleFields, customFields) => {
  const result = [];

  // eslint-disable-next-line no-restricted-syntax
  for (const [key, value] of visibleFields.entries()) {
    if (key.indexOf('custom-field') !== -1) {
      const id = parseInt(key.split('-')[2], 10);
      const customField = customFields.find((field) => field.id === id);

      if (customField) {
        result.push({ ...createCustomFieldColumn(customField), show: value.show });
      }
    } else {
      const column = contactTableColumns[key];

      if (column) {
        result.push({ ...column, show: value.show });
      }
    }
  }

  return result;
};

export const createFieldsFromColumns = (oldColumns) => {
  const result = new Map();

  oldColumns.forEach((column) => {
    if (column.accessor) {
      result.set(column.accessor, { show: column.show });
    }
  });

  return result;
};
